import { Command } from '@/app/tracking/api';

const successStatusKeys = ['passed', 'failed', 'unknown'] as const;
type CourseSuccessStatus = typeof successStatusKeys[number];

export interface CompleteCourseCommandPayload {
  successStatus: CourseSuccessStatus;
}

export const CompleteCourseCommandName = 'complete-course' as const;
export type CompleteCourseCommand =
      Command<typeof CompleteCourseCommandName, CompleteCourseCommandPayload>;
